import { Alert, Grid, Stack, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import moment from 'moment-timezone';
import { useEffect } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { TimePicker } from '../../components/core/DatePicker/TimePicker';
import { useTranslation } from '../../contexts/translation';
import { ShiftInputs } from '../../types/app/shifts.types';
import { dictionary } from '../../utils/core/dictionary';
interface Props {
  onSubmit: SubmitHandler<ShiftInputs>;
  defaultValues?: ShiftInputs;
  onBack: any;
}

export function ShiftForm({ onSubmit, defaultValues, onBack }: Props) {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
  } = useForm<ShiftInputs>();

  useEffect(() => {
    reset({ ...defaultValues });
  }, [defaultValues, reset]);

  const utcTimeOffsetInfo = () => {
    let actualTimezone = moment.tz.guess();
    let utcOffset = moment.tz(actualTimezone).utcOffset();
    let sign = utcOffset > 0 ? ' +' : ' -';
    let hourOffset = moment.utc().startOf('day').add(utcOffset, 'minutes').format('hh:mm');
    return ' (current timezone: ' + actualTimezone + sign + hourOffset + ' hours)';
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TextField
              required
              fullWidth
              label={t('page.shift.edit-input-label-1')}
              {...register('name', { required: t('page.shift.validation-required-name') })}
              error={Boolean(errors.name)}
              helperText={errors.name?.message}
              autoFocus
            />
          </Grid>
          <Grid item xs={12}>
            <TimePicker
              isRequired
              label={t('page.shift.edit-input-label-2')}
              controllerProps={{
                name: 'start',
                control: control,
                inputFormat: 'HH:mm',
                // rules: { required: t('page.shift.validation-required-start') },
              }}
              errors={errors}
            />
          </Grid>
          <Grid item xs={12}>
            <TimePicker
              isRequired
              label={t('page.shift.edit-input-label-3')}
              controllerProps={{
                name: 'end',
                control: control,
                inputFormat: 'HH:mm',
                // rules: { required: t('page.shift.validation-required-end') },
              }}
              errors={errors}
            />
          </Grid>
          <Grid item xs={12}>
            <Alert severity="info">
              {dictionary.TIME_IS_UTC}
              {utcTimeOffsetInfo()}
            </Alert>
          </Grid>
          <Grid item>
            <Stack spacing={2} direction="row">
              <Button type="button" variant="outlined" onClick={onBack}>
                {t('general.action-buttons.back')}
              </Button>
              <Button type="submit" variant="contained" color="success">
                {t('general.action-buttons.save')}
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
